/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type children_ChildAttendanceDayDTO = {
    absenceType?: string;
    closureType?: string;
    contracted?: boolean;
    date: string;
    extra?: boolean;
    extraCodes?: Array<string>;
    firstCheckIn?: string;
    lastCheckOut?: string;
    serviceCodes: Array<string>;
    /**
     * Status: present, absent, no_record, extra, closed, no_contract or not_contracted.
     */
    status: children_ChildAttendanceDayDTO.status;
};
export namespace children_ChildAttendanceDayDTO {
    /**
     * Status: present, absent, no_record, extra, closed, no_contract or not_contracted.
     */
    export enum status {
        PRESENT = 'present',
        ABSENT = 'absent',
        NO_RECORD = 'no_record',
        EXTRA = 'extra',
        CLOSED = 'closed',
        NO_CONTRACT = 'no_contract',
        NOT_CONTRACTED = 'not_contracted',
    }
}

